/**
 * [zgłoszenie właściciela 2026-09-17] ROZPOZNANIE KLAWISZA ZRZUTU EKRANU.
 *
 *   „weź mi to wywal, to nie może tak być, że mam znak wody — to ma być tylko w momencie, jak wykryje
 *    klawisz print screen, inaczej nieee."
 *
 * ⚠️ GRANICE, KTÓRE TRZEBA ZNAĆ, ZANIM SIĘ NA TYM POLEGNIE — i które są powodem, dla którego znak wodny
 * stał wcześniej NA STAŁE:
 *
 *  1. **PrintScreen łapiemy PO FAKCIE.** Windows kopiuje ekran do schowka w chwili naciśnięcia klawisza.
 *     Przeglądarka dostaje zdarzenie już po zrzucie, więc znak wodny NIE ZDĄŻY wejść na TEN obraz.
 *     Wchodzi na następny i zostaje na ekranie przez chwilę — to znacznik i sygnał, nie blokada.
 *  2. **Win+Shift+S (Wycinanie i szkic) to inny przypadek** i tu jest realnie lepiej: skrót otwiera
 *     najpierw nakładkę do zaznaczania obszaru, a obraz powstaje DOPIERO po zaznaczeniu. Znak wodny
 *     zdąży się pokazać i wejdzie na wycinek.
 *  3. **Czego nie złapiemy w ogóle:** telefon skierowany w ekran, nagranie pulpitu, drugi monitor,
 *     narzędzia systemowe uruchomione myszą, maszyna wirtualna. Zdarzenia klawiatury tego nie widzą.
 *  4. W przeglądarce na Windows `PrintScreen` zwykle NIE wywołuje `keydown` — tylko `keyup`.
 *     Dlatego nasłuchujemy OBU zdarzeń; podwójne wywołanie gasi warunek czasu w komponencie.
 *
 * Nie nasłuchujemy utraty ostrości okna ani `visibilitychange`, choć bywa to reklamowane jako
 * „wykrywanie zrzutu": Alt+Tab, przełączenie karty i powiadomienie systemowe wyglądają tak samo,
 * więc znak wodny migałby kilkadziesiąt razy dziennie bez powodu. Właśnie tego właściciel kazał się
 * pozbyć i fałszywy alarm co chwilę byłby tym samym błędem w innym przebraniu.
 */

/** Czy to zdarzenie klawiatury wygląda na próbę zrzutu ekranu. */
export const czyKlawiszZrzutu = (e) => {
    if (!e) return false;
    const klawisz = String(e.key || "");

    // Windows / Linux: dedykowany klawisz (różne przeglądarki nazywają go dwojako).
    if (klawisz === "PrintScreen" || klawisz === "Snapshot") return true;

    // Windows: Win+Shift+S — „Wycinanie i szkic". `metaKey` to klawisz Windows.
    if (e.metaKey && e.shiftKey && klawisz.toLowerCase() === "s") return true;

    // macOS: ⌘+Shift+3 (cały ekran), ⌘+Shift+4 (obszar), ⌘+Shift+5 (panel nagrywania).
    if (e.metaKey && e.shiftKey && ["3", "4", "5"].includes(klawisz)) return true;

    return false;
};

/** Ile czasu znak wodny zostaje na ekranie po wykryciu (ms). */
export const CZAS_ZNAKU_WODNEGO_MS = 6000;
